const TITLE_ID_PATTERN = /^[1-9]\d{0,30}$/;
const VIEW_BY_STATE = {
  paid: "paid",
  to_pay: "topay",
  topay: "topay",
  paid_and_to_pay: "paid",
};

const invalid = () => {
  throw new TypeError("invalid_title_deep_link");
};

const canonicalWorkId = (value) => {
  if (
    typeof value !== "string" ||
    value.length === 0 ||
    value.length > 200 ||
    value.trim() !== value
  ) {
    invalid();
  }
  return value;
};

const canonicalTitleId = (value) => {
  const normalized = typeof value === "number" ? String(value) : value;
  if (typeof normalized !== "string" || !TITLE_ID_PATTERN.test(normalized)) {
    invalid();
  }
  return normalized;
};

export const buildTitleDeepLink = ({ workId, titleId, state }) => {
  const view = VIEW_BY_STATE[state];
  if (!view) invalid();
  const query = new URLSearchParams({
    view,
    searchFor: "id",
    search: canonicalTitleId(titleId),
  });
  return `/dashboard/titulos/${encodeURIComponent(
    canonicalWorkId(workId),
  )}?${query.toString()}`;
};

export const parseTitleDeepLink = (searchParams) => {
  if (!searchParams || typeof searchParams.get !== "function") return null;
  const view = searchParams.get("view");
  const searchFor = searchParams.get("searchFor");
  const search = searchParams.get("search");
  if (
    !new Set(["paid", "topay"]).has(view) ||
    searchFor !== "id" ||
    !TITLE_ID_PATTERN.test(search ?? "")
  ) {
    return null;
  }
  if (
    typeof searchParams.getAll === "function" &&
    ["view", "searchFor", "search"].some(
      (key) => searchParams.getAll(key).length !== 1,
    )
  ) {
    return null;
  }
  return { view, search: { search, searchFor: "id" } };
};
